import Vue from 'vue'
import VueRouter from 'vue-router'
import newsInfo from './newsInfo'
import exchange from './exchange'
import display from './display'
import spectatorService from './spectatorService'
import education from './education'
import appreciate from './appreciate'
import volunteer from './volunteer'
import introduction from './introduction'
Vue.use(VueRouter)
export const srArtContext = `/srArt`

const defaultIndex = {
    path: `/`,
    name: '首页',
    meta: {
        title: '上饶美术馆',
        keepAlive: true
    },
    component: () =>
        import ('../views/index.vue'),
}
const index = {
    path: `/index`,
    name: '首页',
    meta: {
        title: '上饶美术馆',
        keepAlive: true
    },
    component: () =>
        import ('../views/index.vue'),
}

const routes = [
    defaultIndex, index, ...newsInfo, ...exchange, ...display, ...spectatorService, ...education, ...appreciate, ...volunteer, ...introduction
]

const router = new VueRouter({
    base: '/menhu',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router